'use client'

import { motion } from 'motion/react'

const Loading = () => {
  const animationProps = (delay: number) => {
    return {
      initial: { pathLength: 0, pathSpacing: 1 },
      animate: { pathLength: 1, pathSpacing: 1 },
      transition: {
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut' as const,
        repeatType: 'mirror' as const,
        delay: delay,
      },
    }
  }

  return (
    <div className="flex items-center justify-center h-[calc(100vh_-_300px)]">
      <svg className="w-[250px]" viewBox="0 0 92 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <motion.path
          d="M77.1484 27.1797V26.63C78.3662 26.512 78.9554 26.0794 79.0339 24.98V2.42984H75.3015C72.5122 2.54742 71.7269 3.56872 70.8622 5.14015L70.3516 4.94404L71.1768 0.465334H90.5841L91.4088 4.94404L90.8982 5.14015C90.034 3.56872 89.2482 2.54742 86.459 2.42984H82.7269V24.98C82.805 26.0794 83.3946 26.512 84.6125 26.63V27.1797H77.1484Z"
          className="stroke-[#0C0A09]"
          strokeWidth="0.5"
          {...animationProps(0)}
        />
        <motion.path
          d="M39.5493 14.0582C43.8315 14.0582 46.5422 11.9366 46.5422 8.40114C46.5422 4.07948 44.2636 2.35056 40.3745 2.35056C39.4708 2.35056 38.2529 2.39004 37.3102 2.58658V14.0582H39.5493ZM66.7747 0.858086L67.521 4.94373L67.0103 5.13984C66.2246 3.68641 64.7317 1.95792 61.6674 1.95792C59.3102 1.95792 57.1887 3.0187 57.1887 5.68997C57.1887 11.7006 68.5818 12.3688 68.5818 19.9114C68.5818 24.5472 64.7708 27.7686 58.6425 27.7686C56.1279 27.7686 53.9673 27.4154 51.8461 26.5117C48.0351 24.9402 45.2459 22.426 40.453 15.9832H37.3102V24.9797C37.3887 26.0791 37.9779 26.5117 39.1957 26.6297V27.1794H31.8887V26.6297C32.9885 26.5117 33.5386 26.0791 33.6172 24.9797V2.66511C33.5386 1.56485 32.9885 1.13315 31.8887 1.01514V0.465017H41.9455C46.3852 0.465017 50.2747 2.42953 50.2747 7.65448C50.2747 10.5618 47.8781 13.9007 44.5387 15.0795C49.8421 22.8187 53.1026 26.1976 58.6425 26.1976C63.7889 26.1976 65.1243 23.0547 65.1243 20.8546C65.1243 15.3151 53.8887 14.0187 53.8887 6.71169C53.8887 2.58657 57.3067 -0.00658417 61.7854 -0.00658417C64.0636 -0.00658417 65.7135 0.465014 66.7747 0.858086Z"
          className="stroke-[#0C0A09]"
          strokeWidth="0.5"
          {...animationProps(0)}
        />
        <motion.path
          d="M22.1463 2.66445C22.0679 1.56419 21.5178 1.13249 20.418 1.01448V0.464357H27.5679V1.01448C26.4681 1.13249 25.9179 1.56419 25.8394 2.66445V24.979C25.9179 26.0785 26.4681 26.511 27.5679 26.629V27.1787H20.418V26.629C21.5178 26.511 22.0679 26.0785 22.1463 24.979V2.66445Z"
          className="stroke-[#0C0A09]"
          strokeWidth="0.5"
          {...animationProps(0)}
        />
        <motion.path
          d="M5.92149 14.5287V24.979C6.00027 26.0785 6.58945 26.511 7.80725 26.629V27.1787H0.5V26.629C1.60013 26.511 2.15009 26.0785 2.22871 24.979V2.66445C2.15009 1.56419 1.60013 1.13249 0.5 1.01448V0.464357H16.3323L17.1574 4.94306L16.6468 5.13917C15.7822 3.56774 14.9967 2.54644 12.2073 2.42886H5.92149V12.5646H11.5396C13.5823 12.4466 13.8181 12.2106 14.6824 11.1503H15.0359V15.8646L14.643 16.0216C13.9358 14.8823 13.15 14.5287 11.5002 14.5287H5.92149Z"
          className="stroke-[#0C0A09]"
          strokeWidth="0.5"
          {...animationProps(0)}
        />
      </svg>
    </div>
  )
}

export default Loading
